import React, { useRef, useState } from "react";
import { MainCard } from "../../../components/Card/Cards";
import { Checkbox } from "primereact/checkbox";
import SelfDeclaration from "../../../components/Policies/01Declaration";
import { Dialog } from "primereact/dialog";
import DrugStatement from "../../../components/Policies/02DrugStatement";
import DriverRecordSearch from "../../../components/Policies/04DriverRecordSearch";
import LicenseRequirements from "../../../components/Policies/05LicenseRequirements";
import SafetyPolicy from "../../../components/Policies/06SafetyPolicy";
import InspectionPolicy from "../../../components/Policies/07InspectionPolicy";
import HoursService from "../../../components/Policies/08HoursService";
import DisciplinaryPolicy from "../../../components/Policies/09DisciplinaryPolicy";
import MaintenancePolicy from "../../../components/Policies/10MaintenancePolicy";
import MedicalPolicy from "../../../components/Policies/03MedicalPolicy";
import { Button } from "primereact/button";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
export default function Policies() {
  const [model, setModel] = useState(null);
  const [selected, setSelected] = useState(0);
  const toast = useRef(null);
  const navigate = useNavigate();
  const [data, setData] = useState({
    selfDeclaration: false,
    drugStatement: false,
    medicalPolicy: false,
    driverRecordSearch: false,
    licenseRequirements: false,
    safetyPolicy: false,
    inspectionPolicy: false,
    hoursService: false,
    disciplinaeryPolicy: false,
    maintenancePolicy: false,
  });
  const policies = [
    {
      Policy: SelfDeclaration,
      name: "selfDeclaration",
      description:
        "This certifies that this application was completed by me, and that all entries on it and information in it are true and complete to the best of my knowledge. ",
    },
    {
      Policy: DrugStatement,
      name: "drugStatement",
      description: "I agree with Drug statement policy.",
    },
    {
      Policy: MedicalPolicy,
      name: "medicalPolicy",
      description:
        "I agree to inform if my medical status change, or if I can no longer certify conditions as described.",
    },
    {
      Policy: DriverRecordSearch,
      name: "driverRecordSearch",
      description: "I have read and agree to driver record search policy.",
    },
    {
      Policy: LicenseRequirements,
      name: "licenseRequirements",
      description:
        "I certify that I have read and understand the requirements: The provided license is the only one that I possess",
    },
    {
      Policy: SafetyPolicy,
      name: "safetyPolicy",
      description:
        "I	understand this speeding passenger policy and will abide with this policy at all Times, I also understand that failure to abide by the speeding policy is grounds for disciplinary action.",
    },
    {
      Policy: InspectionPolicy,
      name: "inspectionPolicy",
      description:
        "I	acknowledge that I have been trained on the proper procedures to conduct a Pre-Trip Inspection, Post-Trip Inspection, Couple, Uncouple and 5th wheel tug test of a Commercial Motor Vehicle",
    },
    {
      Policy: HoursService,
      name: "hoursService",
      description:
        "I acknowledge that I have been trained in the Hours-of-Service Regulations as they pertain to a Commercial Motor Vehicle driver in Canada and the United States (Regulations 555/06 of the Highway Traffic Act and Regulation 395 of FMCSR.)",
    },
    {
      Policy: DisciplinaryPolicy,
      name: "disciplinaeryPolicy",
      description: "I agree with Disciplinary Policy",
    },
    {
      Policy: MaintenancePolicy,
      name: "maintenancePolicy",
      description:
        "I being an Owner Operator for Shah Transport Freight Lines agree that I will adhere to the Maintenance Policy of Shah Transport Freight Lines.",
    },
  ];

  const headerElement = (
    <span>
      {selected + 1}/{policies?.length}
    </span>
  );



  const footerContent = (
    <div className="w-full flex justify-content-between pt-4">
      <div className="inline-flex align-items-center justify-content-center gap-2">
        {selected ? (
          <Button label="<" severity="secondary" onClick={() => setSelected((prev) => prev - 1)} />
        ) : (
          ""
        )}
        {policies.length !== selected + 1 && (
          <Button label=">" severity="secondary" onClick={() => setSelected((prev) => prev + 1)} />
        )}
      </div>
      <Button
        label="Agree"
        onClick={() =>
          setData((prev) => ({ ...prev, [policies[selected].name]: true }))
        }
        autoFocus
      />
    </div>
  );

  const isAnyKeyFalse = (data) => {
    return Object.values(data).some((value) => !value);
  };

  const submitData = async () => {
    if (isAnyKeyFalse(data)) {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill all required fields",
      });
      return 
    } else {
      try {
        const token = sessionStorage.getItem("token"); // Retrieve token from sessionStorage

        console.log("token", token);
        const response = await axios.post(
          API_BASE_URL + "/api/driver/submit-form",
          { data, authToken: token },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          }
        );
        console.log(response);
        navigate("/employment/form-success")
      } catch (err) {
        alert(err.response?.data?.message || "Failed to save information");
      }
    }
  }
  return (
    <MainCard size="container">
      <Dialog
        header={headerElement}
        footer={footerContent}
        visible={model}
        // style={{ width: "50vw" }}
        className="w-11 md:w-8"
        onHide={() => {
          if (!model) return;
          setModel(false);
        }}
      >
        {policies[selected]?.Policy({})}
      </Dialog>
      {policies?.map((policy, index) => (
        <div className="flex align-items-start gap-3 my-3">
          <Checkbox
            onChange={() => {
              setSelected(index);
              setModel((prev) => !prev);
            }}
            checked={data[policy.name]}
          ></Checkbox>
          <p
            className="m-0"
            onClick={() => {
              setModel((prev) => !prev);
              setSelected(index);
            }}
          >
            {policy?.description}
          </p>
        </div>
      ))}
      <div className="flex justify-content-end mt-4 pr-2">
        <Button label="Submit" onClick={submitData} />
      </div>
    </MainCard>
  );
}
